import publicEnvConfig from '../../env.public.config.json';

const env = {
  NEXT_PUBLIC_STYTCH_B2B_PUBLIC_TOKEN: process.env.NEXT_PUBLIC_STYTCH_B2B_PUBLIC_TOKEN as string,
  DOMAIN: process.env.DOMAIN as string,
  BRIDGE_API_URL: process.env.BRIDGE_API_URL as string,
  BRIDGE_DEV_API_URL: process.env.BRIDGE_DEV_API_URL as string,
  BRIDGE_API_SANDBOX_URL: process.env.BRIDGE_API_SANDBOX_URL as string,
  NEXT_PUBLIC_AUTH_DURATION_MINUTES: parseInt(process.env.NEXT_PUBLIC_AUTH_DURATION_MINUTES as string),
  NEXT_PUBLIC_STYTCH_URL: process.env.NEXT_PUBLIC_STYTCH_URL as string,
  NEXT_PUBLIC_SOCURE_KEY_SANDBOX: process.env.NEXT_PUBLIC_SOCURE_KEY_SANDBOX as string,
  NEXT_PUBLIC_DATA_DOG_APPLICATION_ID: process.env.NEXT_PUBLIC_DATA_DOG_APPLICATION_ID as string,
  NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN as string,
  NEXT_PUBLIC_DATA_DOG_SITE: process.env.NEXT_PUBLIC_DATA_DOG_SITE as string,
  NEXT_PUBLIC_DATA_DOG_SERVICE: process.env.NEXT_PUBLIC_DATA_DOG_SERVICE as string,
  NEXT_NODE_ENV: process.env.NODE_ENV as string,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN as string,
  NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID: process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID as string,
  // Only the NEXT_PUBLIC_ literal inlines into the client bundle; GIT_SHA is runtime-only (server).
  NEXT_PUBLIC_GIT_SHA: process.env.NEXT_PUBLIC_GIT_SHA ?? process.env.GIT_SHA ?? process.env.VERCEL_GIT_COMMIT_SHA,
  SEQUENCE_API_URL: process.env.SEQUENCE_API_URL as string,
  SEQUENCE_API_KEY: process.env.SEQUENCE_API_KEY as string,
  SEQUENCE_API_SECRET: process.env.SEQUENCE_API_SECRET as string,
  SENDGRID_API_KEY: process.env.SENDGRID_API_KEY as string,
  SENDGRID_FROM_EMAIL: process.env.SENDGRID_FROM_EMAIL as string,
  NEXT_PUBLIC_PYLON_APP_ID: process.env.NEXT_PUBLIC_PYLON_APP_ID as string,
  PYLON_IDENTITY_SECRET: process.env.PYLON_IDENTITY_SECRET as string,
  PYLON_PORTAL_SSO_SECRET: process.env.PYLON_PORTAL_SSO_SECRET as string,
  PYLON_ORG_SLUG: process.env.PYLON_ORG_SLUG as string,
  PYLON_ISSUER: process.env.PYLON_ISSUER as string,
  // This value is repo-committed and identical across all environments.
  PYLON_PORTAL_BASE_URL: publicEnvConfig.PYLON_PORTAL_BASE_URL,
};

export const isDev = env.NEXT_NODE_ENV === 'development';
export const isProd = env.NEXT_NODE_ENV === 'production';
export const isServer = typeof window === 'undefined';
export const isClient = !isServer;

export default env;
